const MAX_PRICE = 100000;
const MAX_DECIMALS = 6;

/** Empty means "not set"; otherwise a price from 0 to 100 000 with at most 6 decimals. */
function isPriceValid(value: string): boolean {
	if (value === '') {
		return true;
	}

	const price = Number(value);
	const decimals = value.split('.')[1]?.length ?? 0;

	return Number.isFinite(price) && price >= 0 && price <= MAX_PRICE && decimals <= MAX_DECIMALS;
}

export default isPriceValid;
